import { render, staticRenderFns } from "./firecontrol.vue?vue&type=template&id=31b9a98f&scoped=true&"
import script from "./firecontrol.vue?vue&type=script&lang=js&"
export * from "./firecontrol.vue?vue&type=script&lang=js&"
import style0 from "./firecontrol.vue?vue&type=style&index=0&id=31b9a98f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b9a98f",
  null
  
)

export default component.exports